import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { UpdateProjectDTO } from '@app/models/orders';
import Api from '@app/services/api';

interface IParams {
  project_uid: string;
  data: UpdateProjectDTO;
}

export const useUpdateProjectQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ project_uid, data }: IParams) => {
      await Api.orders.putUpdateProject(project_uid, data);
    },
    onSuccess: async () => {
      message.open({
        type: 'success',
        content: commonT.t('dataPatchSuccess'),
      });
      await client.invalidateQueries(['getProjects']);
    },
    onError: async () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
      await client.invalidateQueries(['getProjects']);
    },
  });
};
